export const common = {
  // 底部导航栏
  'nav.home': '首頁',
  'nav.divination': '測算',
  'nav.fortune': '命理乾坤',
  'nav.academy': '學堂',
  'nav.charm': '能量卡',
  'nav.profile': '我的',

  // 通用按钮
  'common.confirm': '確認',
  'common.cancel': '取消',
  'common.save': '保存',
  'common.delete': '刪除',
  'common.edit': '編輯',
  'common.back': '返回',
  'common.submit': '提交',
  'common.close': '關閉',
  'common.next': '下一步',
  'common.previous': '上一步',
  'common.done': '完成',
  'common.loading': '加載中...',
  'common.retry': '重試',

  // 通用标签
  'common.hot': '熱門',
  'common.new': '新品',
  'common.featured': '精選',
  'common.recommended': '推薦',

  // 通用提示
  'common.success': '操作成功',
  'common.error': '操作失敗',
  'common.networkError': '網絡錯誤，請稍後重試',
  'common.noData': '暫無數據',
  'common.comingSoon': '敬請期待',

  // 命主相關
  'profile.selfTag': '自己',
  'profile.calendarLabel': '公曆',
  'profile.switchBtn': '切換',
  'profile.currentBadge': '目前',
  'profile.selectTitle': '選擇命主',
  'profile.searchPlaceholder': '搜索命主姓名…',
  'profile.switchHint': '點擊命主卡片即可切換，當前命主將用於本次測算',
  'profile.noResults': '未找到匹配的命主',
};

export default common;